import React, { useState } from 'react';
import { getImageSrc } from '../../../utils';
import Img from '../../Img';
import { useZoomableGalleryImage } from './ZoomableGalleryImage';

export default function GalleryImage({
  productInPopup,
  popupHeight=300,
  imageStyle,
  image,
  style={},
  playing,
  fullscreen,
  templateColor,
}) {
  const { handleOpen } = useZoomableGalleryImage();
  const [ imageNotFound, setImageNotFound ] = useState(false);
  const handleClick = () => {
    if (!playing && !fullscreen && !imageNotFound) {
      handleOpen(getImageSrc(image, 'large'), templateColor);
    }
  };

  const handleImageNotFoundError = () => {
    setImageNotFound(true);
  };

  return (
    <div style={{ height: productInPopup ? popupHeight : '98%', ...style }}>
      <Img
        style={playing || imageNotFound || fullscreen
          ? imageStyle
          : { ...imageStyle, cursor: 'zoom-in' }
        }
        src={getImageSrc(image, 'large')}
        onClick={handleClick}
        useSpinner={true}
        spinnerColor={templateColor}
        onErrorCallback={handleImageNotFoundError}
      />
    </div>
  );
}
